import config from '../../config';

class PerformanceUtils {
  measurements = {};

  start(operationName) {
    this.measurements[operationName] = {
      start: Date.now(),
    };
  }

  end(operationName, logResults = true) {
    const item = this.measurements[operationName];

    if (item.end && !Number.isNaN(item.duration)) {
      // only track first end of action (example when called X times inside render()).
      return;
    }

    const end = Date.now();
    this.measurements[operationName] = {
      start: item.start,
      end,
      duration: end - item.start,
    };

    if (logResults) {
      this.showResults(operationName, true);
    }
  }

  showResults(operationName, logResults = false) {
    if (operationName) {
      const message = `[PERF] ${operationName} took ${
        (this.measurements[operationName].duration || 0) / 1000
      }s.`;

      this.printResults(message, logResults);
    } else {
      const message = Object.keys(this.measurements).reduce((result, opName) => {
        const { duration } = this.measurements[opName];
        if (!duration || Number.isNaN(duration)) {
          return result;
        }

        return `${result}\n\n\`[PERF] ${opName} took ${duration / 1000}s.`;
      }, '');
      this.printResults(message, logResults);
    }
  }

  printResults(message, log) {
    if (__TEST__) {
      return;
    }

    if (log) {
      console.log('🔥 ', message);
    } else {
      // eslint-disable-next-line no-alert
      alert(message);
    }
  }
}

const mockedUtils = {
  start: () => null,
  end: () => null,
  printResults: () => null,
  showResults: () => null,
};

const perfUtils = __TEST__ || !config.MEASURE_PERF ? mockedUtils : new PerformanceUtils();

export default perfUtils;
